import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import Button from 'components/atoms/Button';
import { injectIntl } from 'react-intl';

// Actions
import { gtmUserEvent } from 'store/reducers/gtm/actions';

import './ContainerTruncate.scss';

const ns = 'truncate-at__truncate';

class ContainerTruncate extends React.Component {
  constructor(props) {
    super(props);
    this.untruncate = this.untruncate.bind(this);
    this.resize = this.resize.bind(this);
    this.state = {
      seeMore: false,
      previousHeight: 0,
      truncate: true
    };
  }

  componentDidMount() {
    this.resize();
    window.addEventListener('resize', this.resize);
  }

  componentDidUpdate() {
    const { onComponentUpdate } = this.props;
    onComponentUpdate();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  untruncate() {
    this.props.gtmUserEvent(
      'See More Timeslots Link',
      'Clicked',
      'Show All Timeslots',
      'GTM_CURRENT_PAGE > Timeslots Section'
    );
    this.setState({ truncate: false });
  }

  resize() {
    const { previousHeight, truncate } = this.state;
    const { maxContentHeight } = this.props;
    if (truncate && this.divElement) {
      const currentHeight = this.divElement.clientHeight;
      if (previousHeight !== currentHeight && currentHeight > 0) {
        this.setState({
          previousHeight: currentHeight,
          seeMore: maxContentHeight < currentHeight
        });
      }
    }
  }

  childrenWrapper() {
    const { children } = this.props;
    return (
      <div ref={divElement => (this.divElement = divElement)}>{children}</div>
    );
  }

  render() {
    const { seeMore, truncate } = this.state;
    const { intl, ariaLabelConfig } = this.props;
    if (seeMore && truncate) {
      return (
        <div>
          <div className={ns}>{this.childrenWrapper()}</div>
          <div className="truncate-at__button">
            <Button
              buttonTheme="link"
              onClick={this.untruncate}
              id="see_more_button"
              tabIndex={0}
              aria-label={ariaLabelConfig || {}}
            >
              {intl.formatMessage({
                id: 'c8.appointment.page.time.selector.button.see.more'
              })}
            </Button>
          </div>
        </div>
      );
    } else {
      return this.childrenWrapper();
    }
  }
}

ContainerTruncate.propTypes = {
  children: PropTypes.node.isRequired,
  gtmUserEvent: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  maxContentHeight: PropTypes.number,
  onComponentUpdate: PropTypes.func,
  ariaLabelConfig: PropTypes.string
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ gtmUserEvent }, dispatch);
}

export { ns };
export default compose(
  injectIntl,
  connect(
    null,
    mapDispatchToProps
  )
)(ContainerTruncate);



// WEBPACK FOOTER //
// ./src/components/atoms/ContainerTruncate/ContainerTruncate.js